// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__dn2y0","right":"Footer_right__2wKWX","buttons":"Footer_buttons__h5gsa"};